const fullDisplayName = (user) => `${user?.first_name} ${user?.last_name}`;

export { fullDisplayName };
